import {Modal} from "antd";
import {Button} from "../../../../modules/Button";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import './ModalLimitConnection.scss'
import labelMistake from "../../../../image/images/mistake_connection.png";
import {Text} from "../../../../modules";

function ModalLimitConnection({open, onClose}) {
    const {t} = useTranslation();

    function closeSuccessModal(e) {
        onClose(e)
    }

    return (
        <Modal
            classNames={{
                wrapper: 'success_modal__wrapper',
            }}
            open={open}
            onCancel={closeSuccessModal}
            centered

        >
            <div className="success_modal__container">
                <img src={labelMistake} width={"256px"} height={"240px"}
                     className="success_modal__container--img reauth"/>
                <>
                    <div className="success_modal__container--title">
                        {t('agent_limit_title')}
                    </div>
                    <div className="success_modal__container--title">

                        <Text size="f14" font="liteMedium" as="p" color="#9898A6">
                            {t('agent_limit_desc')}
                        </Text>
                    </div>
                </>
                <div className="success_modal__container--buttons">
                    <Button
                        text={t('got_it')}
                        onClick={closeSuccessModal}
                    />
                </div>
            </div>
        </Modal>
    );
}

export default ModalLimitConnection;